// src/pages/checkout/AddressPage.jsx
import React from "react";
import { Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useCheckout } from "./CheckoutContext";
import { useNavigate } from "react-router-dom";

export default function AddressPage() {
  const navigate = useNavigate();
  const { address, setAddress } = useCheckout();
  const set = (k) => (e) => setAddress((a) => ({ ...a, [k]: e.target.value }));

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        收件資料
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="收件人"
            value={address.receiver}
            onChange={set("receiver")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="聯絡電話"
            value={address.phone}
            onChange={set("phone")}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="地址"
            value={address.street}
            onChange={set("street")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="城市"
            value={address.city}
            onChange={set("city")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="郵遞區號"
            value={address.zip}
            onChange={set("zip")}
          />
        </Grid>
      </Grid>
      <Button
        variant="contained"
        size="large"
        onClick={() => navigate("/checkout/payment")}
        // disabled={cartItems.length === 0}
        sx={{ alignSelf: "flex-end" }}
      >
        前往付款
      </Button>
    </Paper>
  );
}
